import { useQueryFetch } from 'sonata-react-components';
import { isDOOHCampaign } from 'sonata-static-storage/lib/helpers/campaign.helpers';

import { getDoohAudience } from '@/services/doohAudience.service';
import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors';

import type { DoohAudience, DoohAudienceEntity } from '@/services/doohAudience.service';

/** The stored audience of a DOOH insertion order / line item (nothing is fetched for another channel or without id) */
export function useDoohAudience(
  entity: DoohAudienceEntity,
  id: string | undefined,
  type: string | undefined
): { doohAudience?: DoohAudience; isFetching: boolean } {
  const userEntity = useGlobalStore(getUser);
  const { data, isFetching } = useQueryFetch(
    ['doohAudience', entity, id],
    () => getDoohAudience(entity, userEntity.get('id')!, id!),
    { enabled: Boolean(id && type && isDOOHCampaign(type)), staleTime: 0 }
  );

  return { doohAudience: data, isFetching };
}
